import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { AlertTriangle } from "lucide-react";

export const UsageLimitDialog = () => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    const handler = (e) => {
      setMessage(e.detail || "");
      setOpen(true);
    };
    window.addEventListener("usage-limit", handler);
    return () => window.removeEventListener("usage-limit", handler);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent data-testid="usage-limit-dialog">
        <DialogHeader>
          <div className="w-12 h-12 rounded-full bg-amber-100 flex items-center justify-center mb-2">
            <AlertTriangle className="w-6 h-6 text-amber-600" />
          </div>
          <DialogTitle className="font-heading">Just a moment</DialogTitle>
          <DialogDescription className="text-slate-600 pt-1">
            {message}
          </DialogDescription>
        </DialogHeader>
        <div className="flex justify-end">
          <Button
            className="bg-[#547d91] hover:bg-[#456a7a] rounded-full"
            onClick={() => setOpen(false)}
            data-testid="usage-limit-dismiss"
          >
            Got it
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
